import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/universes';

export async function query(): Promise<any> {
	const response: Response = await BBApi.get(rootUrl);
	const json: any = await response.json();
	return json;
}

export async function get(id: number): Promise<any> {
	const response: Response = await BBApi.get(rootUrl + `/${id}`);
	const json: any = await response.json();
	return json;
}

export async function create(universe: any): Promise<any> {
	throw new Error('Not implemented');
}

export async function update(id: number, universe: any): Promise<void> {
	throw new Error('Not implemented');
}

export async function remove(id: number): Promise<void> {
	throw new Error('Not implemented');
}

export async function getMemberCount(universeId: number, dateFrom?: string): Promise<any> {
	const url = new URL(rootUrl + `/member-count/${universeId}`);
	if (dateFrom) url.searchParams.append('dateFrom', dateFrom)
	
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json.memberCount;
}

export async function getAgeDistribution(universeId: number): Promise<any> {
	const response: Response = await BBApi.get(rootUrl + `/age-distribution/${universeId}`);
	const json: any = await response.json();
	return json;
}

export async function getGenderDistribution(universeId: number): Promise<any> {
	const response: Response = await BBApi.get(rootUrl + `/gender-distribution/${universeId}`);
	const json: any = await response.json();
	return json;
}

export async function getMemberLocations(universeId: number): Promise<any> {
	const response: Response = await BBApi.get(rootUrl + `/member-locations/${universeId}`);
	const json: any = await response.json();
	return json;
}
